(() => {
  const formatNumbers = (root = document) => {
    root.querySelectorAll('[data-buga-number]').forEach((node) => {
      const value = Number(node.dataset.bugaNumber);
      if (Number.isFinite(value)) node.textContent = new Intl.NumberFormat('en-US').format(value);
    });
  };

  const initAccordions = (root = document) => {
    root.querySelectorAll('[data-buga-accordion-group]').forEach((group) => {
      if (group.dataset.bugaAccordionReady === 'true') return;
      group.dataset.bugaAccordionReady = 'true';
      const items = [...group.querySelectorAll(':scope > details.buga-pdp-accordion')];
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item && other.open) other.removeAttribute('open');
          });
        });
      });
    });
  };

  const initGalleryReveal = (root = document) => {
    const items = root.querySelectorAll("main[data-template^='product'] .product-information__media .product-media-container");
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-buga-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-buga-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '120px 0px', threshold: 0.04 });
    items.forEach((item) => {
      if (item.dataset.bugaRevealReady === 'true') return;
      item.dataset.bugaRevealReady = 'true';
      observer.observe(item);
    });
  };

  const init = (root = document) => {
    formatNumbers(root);
    initAccordions(root);
    initGalleryReveal(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Desktop only: Horizon replaces the media gallery after a color variant change.
  // Re-run BUGA's reveal logic for the freshly inserted gallery so the selected
  // variant image never remains at opacity .001. Mobile slideshow behavior is untouched.
  if ('MutationObserver' in window) {
    const desktopGalleryObserver = new MutationObserver((mutations) => {
      if (!window.matchMedia('(min-width: 750px)').matches) return;

      const galleryChanged = mutations.some((mutation) =>
        [...mutation.addedNodes].some((node) =>
          node instanceof Element &&
          (node.matches('media-gallery') || node.querySelector?.('media-gallery'))
        )
      );

      if (!galleryChanged) return;
      requestAnimationFrame(() => initGalleryReveal(document));
    });

    desktopGalleryObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
